import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, ShieldAlert, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function TrialBanner() {
  const { firm, user } = useAuth();
  const [hidden, setHidden] = useState(false);
  if (!firm || firm.status !== "trial" || !firm.trial_ends_at || hidden) return null;
  const days = Math.max(0, Math.ceil((new Date(firm.trial_ends_at) - Date.now()) / 86400000));
  if (days > 7) return null;
  const urgent = days <= 2;
  return (
    <div className={`flex items-center gap-3 px-4 py-2.5 text-sm border-b ${urgent ? "bg-red-500/10 border-red-500/30 text-red-100" : "bg-[var(--brand)]/10 border-[var(--brand)]/30 text-slate-100"}`} data-testid="trial-banner">
      <Clock className={`w-4 h-4 shrink-0 ${urgent ? "text-red-300" : "text-[var(--brand)]"}`} />
      <p className="flex-1"><span className="font-semibold" data-testid="trial-banner-days">{days === 0 ? "Your trial ends today" : `${days} day${days === 1 ? "" : "s"} left in your JurisOS trial`}</span>
        <span className="text-slate-400"> — subscribe to keep {firm.name} running without interruption.</span></p>
      {user?.role === "admin" && <Link to="/settings#billing" className="btn-gold inline-flex items-center gap-1.5 h-8 px-3 rounded-md text-xs" data-testid="trial-banner-upgrade-button">Upgrade now <ArrowRight className="w-3.5 h-3.5" /></Link>}
      <button onClick={() => setHidden(true)} className="text-slate-500 hover:text-white" aria-label="Dismiss" data-testid="trial-banner-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}

export function ImpersonationBanner() {
  const { user, logout } = useAuth();
  if (!user?.impersonated_by) return null;
  return (
    <div className="flex items-center gap-3 px-4 py-2 text-xs bg-amber-500/15 border-b border-amber-500/40 text-amber-100" data-testid="impersonation-banner">
      <ShieldAlert className="w-4 h-4 text-amber-300" />
      <p className="flex-1">JurisOS support session — you are viewing this workspace as <span className="font-semibold">{user.name}</span> (signed in by <span className="font-mono">{user.impersonated_by}</span>). Session expires in 60 minutes.</p>
      <button onClick={() => { logout(); window.location.href = "/platform"; }} className="underline" data-testid="impersonation-exit-button">Exit to console</button>
    </div>
  );
}
